import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../components/Common/TittleLine";

import {
  PageWrapper,
  CierreContainer,
  SearchRow,
  FieldWrapper,
  FieldHeader,
  FieldInput,
  PrecertificacionLabel,
} from "../styles/CierreCuentaClinicaStyles";

import useEmpresa from "../../../hooks/useEmpresa";
import { useMountEffect, useUpdateEffect, useUnmountEffect } from "../../../hooks/LifeCycle";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import CustomAlert from "../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import EgresosActions from "../../../stores/hospitalizacion/egresos/Actions";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import DetalleCierreCuentaClinica from "../components/DetalleCierreCuentaClinica";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { PSS_TYPE } from "../../../utils/Constant";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { RAMO_HOSPITALIZACION } from "../utils/HospitalizacionConstants";
import { validarEstatusHojaQuirurgica } from "../utils/ValidacionesHojaQuirurgicaUtils";

const mapIngresoEncabezadoToIngreso = (encabezado) => {
  if (!encabezado)  return null;

  return {
    ...encabezado,
    numeroIngreso: encabezado.numeroIngreso,
    nombreDelPaciente: encabezado.nombreAfiliado,
    documento: encabezado.cedula,
    descripcionServicio: encabezado.descripcionServicio,
    origenInternamiento: encabezado.origenInternamineto,
    causaInternamiento:
      encabezado.codigoMotivoEgreso != null && encabezado.codigoMotivoEgreso !== ""
        ? String(encabezado.codigoMotivoEgreso)
        : encabezado.motivoEgreso,
    fechaIngreso: encabezado.fechaIngreso,
    fechaSalida: encabezado.fechaSalida,
    edad: "",
    sexo: encabezado.sexo,
    tipoPersonaHospitalizada: encabezado.tipoAsegurado,
    telefono: encabezado.telefonos,
  };
};

const CierreCuentaClinicaScreen = (props) => {
  const history = useHistory();
  const location = useLocation();

  useMountEffect(() => {
    props.limpiarIngresosPss?.();
    props.limpiarCoberturasCierreCuenta?.();
    props.limpiarValidarServicioAmbulatorio?.();
    props.limpiarValidarAfiliadoVigente?.();
    props.limpiarConsultarEstatusHojaQuirurgica?.();
    props.limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
    // Cargar parámetros de días hospitalarios y días registro egresos para validaciones
    props.consultarDiasHospitalarios?.();
    // Resetear el estado de ingreso seleccionado y bloqueo por hoja QX
    setSelectedIngreso(null);
    setFormularioBloqueadoPorHojaQX(false);
  });

  useMountEffect(() => {
    if (props?.authUserData?.prestador?.tipoPss === PSS_TYPE.MEDICO) {
      history.push("/dashboard");
      return;
    }

    if (props?.authUserData?.prestador?.tipoPss === PSS_TYPE.NO_MEDICO) {
      const codigoPss = props?.authUserData?.prestador?.codigo;
      if (codigoPss && Number(codigoPss) !== 0) {
        props.consultarTipoPssNoMedico({ CodigoPss: codigoPss });
      }
    }
  });

  const {
    authUserData,
    consultarIngresosPssData,
    consultarIngresosPssLoading,
    consultarIngresosPssError,
    consultarCoberturasCierreCuenta,
    consultarCoberturasCierreCuentaLoading,
    consultarCoberturasCierreCuentaError,
    validarServicioAmbulatorioData,
    validarServicioAmbulatorioLoading,
    validarServicioAmbulatorio,
    limpiarValidarServicioAmbulatorio,
    consultarTipoPssNoMedicoData,
    calcularOxigenoLoading,
    consultarEstatusHojaQuirurgica,
    consultarEstatusHojaQuirurgicaLoading,
    consultarEstatusHojaQuirurgicaError,
    limpiarConsultarEstatusHojaQuirurgica,
    consultaIngresoDetalleCoberturaHojaQxData,
    consultaIngresoDetalleCoberturaHojaQxLoading,
    consultaIngresoDetalleCoberturaHojaQxError,
    limpiarConsultaIngresoDetalleCoberturaHojaQx,
    consultarDiasHospitalariosData,
  } = props;

  const empresa = useEmpresa();
  const numeroMedico = authUserData?.prestador?.codigo;

  const [formData, setFormData] = useState({
    anio: "",
    numeroIngreso: "",
  });

  const { anio, numeroIngreso } = formData;

  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [selectedIngreso, setSelectedIngreso] = useState(null);
  const [formularioBloqueadoPorHojaQX, setFormularioBloqueadoPorHojaQX] = useState(false);
  
  // Ref para rastrear el encabezado anterior y evitar validaciones innecesarias
  const encabezadoAnteriorRef = useRef(null);
  // Ref para ejecutar flujo de hoja quirúrgica solo cuando el ingreso se cargó por búsqueda (no cuando solo cambió por eliminar cobertura)
  const cargaIngresoPorBusquedaRef = useRef(false);

  // Escuchar cuando se guarda una validación de hoja quirúrgica en otra ventana
  useEffect(() => {
    const handleValidacionGuardada = (e) => {
      if (e.key === 'validacionHojaQXGuardada' && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          const secuencialActual = numeroIngreso;
          
          // Si la validación es para el ingreso actual, recargar
          if (data.numeroIngreso === secuencialActual && secuencialActual) {
            cargaIngresoPorBusquedaRef.current = true;
            // Volver a consultar el ingreso para actualizar checkQuirurgica
            const payload = {
              Compania: empresa?.CODIGO,
              Reclamante: numeroMedico,
              Ramo: RAMO_HOSPITALIZACION,
              Secuencial: numeroIngreso,
              Ano: anio,
            };
            
            props.consultarIngresosPss(payload);
          }
        } catch (error) {
        }
      }
    };

    window.addEventListener('storage', handleValidacionGuardada);
    
    return () => {
      window.removeEventListener('storage', handleValidacionGuardada);
    };
  }, [numeroIngreso, anio, empresa?.CODIGO, numeroMedico, props]);

  useUnmountEffect(() => {
    props.limpiarIngresosPss?.();
    props.limpiarCoberturasCierreCuenta?.();
    props.limpiarValidarServicioAmbulatorio?.();
    props.limpiarValidarAfiliadoVigente?.();
    props.limpiarConsultarEstatusHojaQuirurgica?.();
    props.limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
  });

  const onStateChange = (key) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useMountEffect(() => {
    const currentYear = new Date().getFullYear().toString();
    
    // Leer query params de la URL
    const params = new URLSearchParams(location.search);
    const numeroIngresoParam = params.get('numeroIngreso');
    
    if (numeroIngresoParam) {
      // Dividir el número de ingreso en año y secuencial
      // Formato esperado: "2026-9661450"
      const partes = numeroIngresoParam.split('-');
      
      if (partes.length === 2) {
        const [ano, secuencial] = partes;
        
        // Setear los valores en el formulario
        setFormData({
          anio: ano,
          numeroIngreso: secuencial,
        });
        
        // Esperar un momento para que el estado se actualice y luego buscar
        setTimeout(() => {
          cargaIngresoPorBusquedaRef.current = true;
          const payload = {
            Compania: empresa?.CODIGO,
            Reclamante: numeroMedico,
            Ramo: RAMO_HOSPITALIZACION,
            Secuencial: secuencial,
            Ano: ano,
          };
          
          props.consultarIngresosPss(payload);
        }, 100);
      }
    } else {
      // Si no hay query param, simplemente setear el año actual
      setFormData((prev) => ({
        ...prev,
        anio: currentYear,
      }));
    }
  });

  useUpdateEffect(() => {
    if (!isObjectEmpty(consultarIngresosPssError)) {
      setAlertConfig({
        type: "info",
        title: "¡Información!",
        message: "El número de ingreso no existe en nuestros registros. Verifique los datos e intente nuevamente.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
    }
  }, [consultarIngresosPssError]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(consultarCoberturasCierreCuentaError)) {
      mostrarErrorGenerico(
        consultarCoberturasCierreCuentaError,
        () => {},
        setAlertConfig,
        setShowAlert
      );
    }
  }, [consultarCoberturasCierreCuentaError]);

  // Efecto para manejar la respuesta de consultar ingreso detalle cobertura hoja QX
  // Este es el endpoint que realmente contiene los estatus de las coberturas
  useUpdateEffect(() => {
    // Esperar a que termine de cargar
    if (consultaIngresoDetalleCoberturaHojaQxLoading) return;

    // Manejar errores del segundo endpoint
    if (!isObjectEmpty(consultaIngresoDetalleCoberturaHojaQxError)) {
      setAlertConfig({
        type: "error",
        title: "¡Error!",
        message: consultaIngresoDetalleCoberturaHojaQxError?.mensaje || "Error al consultar el detalle de coberturas de la hoja quirúrgica.",
        onConfirm: () => {
          setShowAlert(false);
          limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
        },
      });
      setShowAlert(true);
      return;
    }

    // Cuando tenemos los datos del detalle de coberturas, hacer la validación
    if (!isObjectEmpty(consultaIngresoDetalleCoberturaHojaQxData)) {
      // Verificar si el ingreso está convertido ANTES de procesar
      const encabezado = consultarIngresosPssData?.ingresoEncabezado;
      const isConvertido = encabezado?.estatusDesc === "CONVERTIDO";
      
      if (isConvertido) {
        // Si está convertido, solo limpiar y no hacer nada más
        limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
        
        // Dispatch evento para que el listener muestre el mensaje
        window.dispatchEvent(new CustomEvent('insertarCoberturasHojaQX', {
          detail: { coberturas: [] }
        }));
        return;
      }
      
      // Obtener las coberturas del detalle
      const coberturas = 
        consultaIngresoDetalleCoberturaHojaQxData?.data?.coberturas || 
        consultaIngresoDetalleCoberturaHojaQxData?.coberturas ||
        [];
      
      // Validar usando el campo 'estatus' de las coberturas
      const validacion = validarEstatusHojaQuirurgica(coberturas);

      // Actualizar el estado de bloqueo según la validación
      setFormularioBloqueadoPorHojaQX(validacion.debeBloquear);

      if (validacion.mensaje) {
        // Determinar el tipo de alerta según el tipo de estatus
        let tipoAlerta = "info";
        if (validacion.tipoEstatus === "PENDIENTE" || validacion.tipoEstatus === "RECHAZADO" || validacion.tipoEstatus === "APROBACION_PARCIAL") {
          tipoAlerta = "error";
        } else if (validacion.tipoEstatus === "COMPLETADO") {
          tipoAlerta = "success";
        }

        setAlertConfig({
          type: tipoAlerta,
          title: tipoAlerta === "success" ? "¡Éxito!" : tipoAlerta === "error" ? "¡Atención!" : "¡Información!",
          message: validacion.mensaje,
          onConfirm: () => {
            setShowAlert(false);
            limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
            
            // Si todas están completadas, procesar las coberturas para insertarlas en la tabla
            if (validacion.tipoEstatus === "COMPLETADO" && coberturas.length > 0) {
              // Dispatch evento personalizado con las coberturas a procesar
              window.dispatchEvent(new CustomEvent('insertarCoberturasHojaQX', {
                detail: { coberturas }
              }));
            }
          },
        });
        setShowAlert(true);
      }

      limpiarConsultaIngresoDetalleCoberturaHojaQx?.();
    }
  }, [consultaIngresoDetalleCoberturaHojaQxData, consultaIngresoDetalleCoberturaHojaQxError, consultaIngresoDetalleCoberturaHojaQxLoading, limpiarConsultaIngresoDetalleCoberturaHojaQx]);

  // Efecto para manejar errores del primer endpoint (consultar estatus hoja quirúrgica)
  useUpdateEffect(() => {
    if (consultarEstatusHojaQuirurgicaLoading) return;

    if (!isObjectEmpty(consultarEstatusHojaQuirurgicaError)) {
      // En caso de error, mostrar mensaje genérico y bloquear formulario
      setAlertConfig({
        type: "error",
        title: "¡Error!",
        message: consultarEstatusHojaQuirurgicaError?.mensaje || "Error al consultar el estatus de la hoja quirúrgica.",
        onConfirm: () => {
          setShowAlert(false);
          limpiarConsultarEstatusHojaQuirurgica?.();
        },
      });
      setShowAlert(true);
    }
  }, [consultarEstatusHojaQuirurgicaError, consultarEstatusHojaQuirurgicaLoading, limpiarConsultarEstatusHojaQuirurgica]);

  const showModalLoader = () =>
    consultarIngresosPssLoading || consultarCoberturasCierreCuentaLoading || calcularOxigenoLoading;

  const buscarIngresos = () => {
    const { anio, numeroIngreso } = formData;

    let mensajeValidacion = null;

    if (!camposCompletos({ anio, numeroIngreso })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    }

    if (!mensajeValidacion && anio && anio.toString().length > 4) {
      mensajeValidacion = "El año debe tener máximo 4 dígitos.";
    }

    if (!mensajeValidacion && !numeroMedico) {
      mensajeValidacion =
        "No se encontró el código del prestador en la sesión. Favor cerrar sesión e ingresar nuevamente o contactar soporte.";
    }

    if (mensajeValidacion) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: mensajeValidacion,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    const payload = {
      Compania: empresa?.CODIGO,
      Reclamante: numeroMedico,
      Ramo: RAMO_HOSPITALIZACION,
      Secuencial: numeroIngreso,
      Ano: anio,
    };

    // Limpiar estado al iniciar nueva búsqueda para que el nuevo ingreso no herede bloqueos del anterior
    setSelectedIngreso(null);
    setFormularioBloqueadoPorHojaQX(false);
    encabezadoAnteriorRef.current = null;
    limpiarConsultarEstatusHojaQuirurgica?.();
    limpiarConsultaIngresoDetalleCoberturaHojaQx?.();

    cargaIngresoPorBusquedaRef.current = true;
    props.consultarIngresosPss(payload);
  };

  useEffect(() => {
    if (!consultarIngresosPssData) {
      setSelectedIngreso(null);
      encabezadoAnteriorRef.current = null;
      setFormularioBloqueadoPorHojaQX(false);
      return;
    }

    if (consultarIngresosPssData.ingresoEncabezado) {
      const encabezado = consultarIngresosPssData.ingresoEncabezado;
      
      // Validar que el tipo de servicio sea uno de los permitidos
      const codigoServicio = String(encabezado?.codigoServicio || "");
      const serviciosPermitidos = ["1", "2", "5", "11", "12"]; // Ambulatorio, Hospitalización, Maternidad, Parto, Cesárea
      
      if (codigoServicio && !serviciosPermitidos.includes(codigoServicio)) {
        // Resetear la búsqueda
        props.limpiarIngresosPss?.();
        setSelectedIngreso(null);
        encabezadoAnteriorRef.current = null;
        setFormularioBloqueadoPorHojaQX(false);
        
        // Mostrar alerta
        setAlertConfig({
          type: "warning",
          title: "¡Servicio no permitido!",
          message: "Por esta vía solo se pueden trabajar ingresos con los siguientes servicios: Ambulatorio, Hospitalización, Maternidad, Parto o Cesárea. Para otros tipos de servicios, debe comunicarse con nuestro Centro de Atención al Cliente.",
          onConfirm: () => setShowAlert(false),
        });
        setShowAlert(true);
        return;
      }

      // Validar precertificación
      const tienePrecertificacion = 
        encabezado?.numeroPrecertificacion != null && 
        encabezado?.numeroPrecertificacion !== 0;
      
      // Validar que servicios de Maternidad, Parto y Cesárea NO tengan precertificación
      if ((codigoServicio === "5" || codigoServicio === "11" || codigoServicio === "12") && tienePrecertificacion) {
        const tipoServicioNombre = 
          codigoServicio === "5" ? "Maternidad" : 
          codigoServicio === "11" ? "Parto" : "Cesárea";
        
        // Resetear la búsqueda
        props.limpiarIngresosPss?.();
        setSelectedIngreso(null);
        encabezadoAnteriorRef.current = null;
        setFormularioBloqueadoPorHojaQX(false);
        
        // Mostrar alerta
        setAlertConfig({
          type: "error",
          title: "¡Error de validación!",
          message: `Este servicio ${tipoServicioNombre} no aplica para precertificación.\n\nPor favor digite el número de ingreso para continuar o contacte al CAC para asistencia.`,
          onConfirm: () => setShowAlert(false),
        });
        setShowAlert(true);
        return;
      }
      
      // Validar que servicios Ambulatorio y Hospitalización tengan precertificación
      if ((codigoServicio === "1" || codigoServicio === "2") && !tienePrecertificacion) {
        const tipoServicioNombre = codigoServicio === "1" ? "Ambulatorio" : "Hospitalización";
        
        // Resetear la búsqueda
        props.limpiarIngresosPss?.();
        setSelectedIngreso(null);
        encabezadoAnteriorRef.current = null;
        setFormularioBloqueadoPorHojaQX(false);
        
        // Mostrar alerta
        setAlertConfig({
          type: "error",
          title: "¡Ingreso sin precertificación!",
          message: `Este ingreso de tipo ${tipoServicioNombre} no está precertificado. Por este motivo no se puede trabajar por esta vía. Para más información, comuníquese con nuestro Centro de Atención al Cliente.`,
          onConfirm: () => setShowAlert(false),
        });
        setShowAlert(true);
        return;
      }
      
      // Crear una clave única para identificar el encabezado (número de ingreso)
      const claveEncabezado = encabezado?.numeroIngreso || null;
      
      // Verificar si el encabezado cambió realmente (no solo el detalle)
      const encabezadoCambio = encabezadoAnteriorRef.current !== claveEncabezado;
      
      // Actualizar el ref con la clave actual
      encabezadoAnteriorRef.current = claveEncabezado;

      const encabezadoMapped = mapIngresoEncabezadoToIngreso(encabezado);

      setSelectedIngreso({
        ...consultarIngresosPssData,
        ingresoEncabezado: encabezadoMapped,
        ingresoDetalle: Array.isArray(consultarIngresosPssData?.ingresoDetalle)
          ? consultarIngresosPssData.ingresoDetalle
          : [],
      });

      const ingresoDetalle = consultarIngresosPssData?.ingresoDetalle || [];
      const tieneDetalle = Array.isArray(ingresoDetalle) && ingresoDetalle.length > 0;
      const checkQuirurgica = encabezado?.checkQuirurgica;
      const isConvertido = encabezado?.estatusDesc === "CONVERTIDO";
      const checkPdss = encabezado?.checkPdss;

      // Si este ingreso no requiere validación de hoja quirúrgica, asegurar que el formulario no quede bloqueado
      if (checkQuirurgica !== "S") {
        setFormularioBloqueadoPorHojaQX(false);
      }

      // 1. Validar servicio ambulatorio (asíncrono, no bloquea)
      // Solo ejecutar si el encabezado cambió realmente
      if (encabezadoCambio) {
        const tienePrecertificacion =
          encabezado?.numeroPrecertificacion != null &&
          encabezado?.numeroPrecertificacion !== 0;

        if (tienePrecertificacion) {
          const poliza = encabezado?.poliza || "";
          const polizaParts = poliza.split("-");
          const ramo = polizaParts.length >= 2 ? Number(polizaParts[1]) : RAMO_HOSPITALIZACION;

          const [anioIngreso, secuencialIngreso] = (encabezado?.numeroIngreso || "").split("-");

          validarServicioAmbulatorio({
            Ano: Number(anioIngreso) || Number(anio),
            Compania: Number(empresa?.CODIGO),
            Ramo: ramo,
            Secuencial: Number(secuencialIngreso) || Number(numeroIngreso),
            Reclamante: Number(numeroMedico),
            Servicio: Number(encabezado?.codigoServicio),
          });
        } else {
          limpiarValidarServicioAmbulatorio();
        }
      }

      // 2. VALIDACIÓN PRIORITARIA: checkPdss (bloquea automáticamente todo)
      // Solo ejecutar si el encabezado cambió realmente
      if (encabezadoCambio && encabezado?.checkPdss === "S") {
        setAlertConfig({
          type: "info",
          title: "¡Atención!",
          message:
            "No es posible registrar el egreso porque la cobertura aplica únicamente por PDSS. Para más información debe comunicarse con nuestro Centro de Atención al Cliente.",
          onConfirm: () => {
            setShowAlert(false);
          },
        });
        setShowAlert(true);
        return; // Detener ejecución - PDSS bloquea todo
      }

      // 3. Validación de checkQuirurgica
      // Para checkQuirurgica === null || 'N': solo si encabezado cambió Y NO tiene detalle
      if (encabezadoCambio && !tieneDetalle) {
        // Si checkQuirurgica es null o 'N', preguntar si necesita validación
        if (checkQuirurgica === null || checkQuirurgica === 'N') {
          setAlertConfig({
            type: "confirm",
            title: "¿Este ingreso necesita validación de hojas quirúrgicas?",
            message: "Por favor seleccione una opción para continuar.",
            confirmText: "Sí, validar hoja quirúrgica",
            cancelText: "No, seguir con el egreso",
            onConfirm: () => {
              setShowAlert(false);
              // Abrir nueva ventana con la ruta de validación
              const numeroIngresoCompleto = encabezado?.numeroIngreso || "";
              const numeroIngresoParts = numeroIngresoCompleto.split("-");
              const secuencial = numeroIngresoParts.length >= 2 ? numeroIngresoParts[1] : "";
              
              if (secuencial) {
                window.open(`/validar-hoja-QX/${secuencial}`, "_blank");
              }
            },
            onCancel: () => {
              setShowAlert(false);
              // Continuar normalmente con el egreso
            },
          });
          setShowAlert(true);
          return; // Detener la ejecución aquí para este caso
        }
      }

      // Para checkQuirurgica === 'S': ejecutar solo cuando el ingreso se cargó por búsqueda (no cuando consultarIngresosPssData cambió solo por eliminar cobertura)
      if (checkQuirurgica === 'S') {
        const debeConsultarHojaQX = cargaIngresoPorBusquedaRef.current;
        cargaIngresoPorBusquedaRef.current = false;

        if (debeConsultarHojaQX) {
          // Extraer número de ingreso del formato "2026-9661351"
          const numeroIngresoCompleto = encabezado?.numeroIngreso || "";
          const numeroIngresoParts = numeroIngresoCompleto.split("-");
          const numeroIngresoVal = numeroIngresoParts.length >= 2 ? numeroIngresoParts[1] : null;
          const codigoAseg = encabezado?.numeroAsegurado || 0;
          const codigoPss = numeroMedico || 0;

          if (numeroIngresoVal && codigoPss && codigoAseg && typeof consultarEstatusHojaQuirurgica === 'function') {
            consultarEstatusHojaQuirurgica({
              numeroIngreso: numeroIngresoVal,
              codigoPss,
              codigoAseg,
            });
          }
        }
        return; // Detener ejecución (ya sea esperando respuesta de hoja QX o porque no corresponde re-consultar)
      }

      return;
    }

    let ingresos = [];

    if (Array.isArray(consultarIngresosPssData?.ingresos)) {
      ingresos = consultarIngresosPssData.ingresos;
    } else if (Array.isArray(consultarIngresosPssData)) {
      ingresos = consultarIngresosPssData;
    }

    if (ingresos.length > 0) {
      const first = ingresos[0];
      setSelectedIngreso(first);
    } else {
      setSelectedIngreso(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Nota: anio, numeroIngreso y consultarEstatusHojaQuirurgica se omiten intencionalmente de las dependencias
    // para evitar que el useEffect se ejecute cuando el usuario cambia estos campos o cuando se llama la función.
    // El useEffect debe ejecutarse SOLO cuando consultarIngresosPssData cambia (nuevos datos del backend).
  }, [consultarIngresosPssData, empresa?.CODIGO, numeroMedico, validarServicioAmbulatorio, limpiarValidarServicioAmbulatorio, authUserData, consultarCoberturasCierreCuenta]);

  const handleConsultarCoberturas = useCallback((tipoServicioFormulario, numeroPagina = 1, cobertura = null) => {
    const encabezado = consultarIngresosPssData?.ingresoEncabezado;
    if (!encabezado) return;

    // Usar el tipo de servicio del formulario si está disponible, sino usar el del encabezado
    const codigoServicio = tipoServicioFormulario 
      ? Number(tipoServicioFormulario) 
      : Number(encabezado.codigoServicio || 0);

    const payloadCoberturas = {
      Compania: empresa?.CODIGO,
      Reclamante: numeroMedico,
      Servicio: codigoServicio,
      TipoReclamante: authUserData?.prestador?.tipoPss || "NO_MEDICO",
      Plan: encabezado.planPoliza,
      tamanoPagina: 10,
      numeroPagina: numeroPagina || 1,
    };

    // Agregar cobertura solo si se proporciona
    if (cobertura != null && cobertura !== "") {
      payloadCoberturas.cobertura = Number(cobertura);
    }

    consultarCoberturasCierreCuenta(payloadCoberturas);
  }, [
    consultarIngresosPssData,
    empresa?.CODIGO,
    numeroMedico,
    authUserData,
    consultarCoberturasCierreCuenta,
  ]);

  return (
    <CustomLayout showMenuNav={true}>
      <PageWrapper>
        <Section>
          <TittleLine title={"Cierre de cuentas clínicas"} weight={"bold"} />
        </Section>

        <Section>
          <CierreContainer>
            <SearchRow>
              <FieldWrapper>
                <FieldHeader>Año</FieldHeader>
                <FieldInput
                  type="text"
                  placeholder="Año"
                  value={anio}
                  maxLength={4}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    onStateChange("anio")(value);
                  }}
                />
              </FieldWrapper>

              <FieldWrapper>
                <FieldHeader>Número de Ingreso</FieldHeader>
                <FieldInput
                  type="text"
                  placeholder="Número de Ingreso"
                  value={numeroIngreso}
                  maxLength={8}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                    onStateChange("numeroIngreso")(value);
                  }}
                />
              </FieldWrapper>

              <CustomButton
                label={"Buscar"}
                onClick={buscarIngresos}
                isLoading={consultarIngresosPssLoading}
                height={"38px"}
                width={"300px"}
              />

              {selectedIngreso?.ingresoEncabezado?.numeroPrecertificacion &&
                selectedIngreso.ingresoEncabezado.numeroPrecertificacion !== 0 && (
                  <PrecertificacionLabel>
                    Num. Precertificación: {selectedIngreso.ingresoEncabezado.numeroPrecertificacion}
                  </PrecertificacionLabel>
                )}
            </SearchRow>
          </CierreContainer>
        </Section>

        <CustomSeparator height={"20px"} />

        <CheckRender allowed={!!selectedIngreso}>
          <Section>
            <DetalleCierreCuentaClinica
              ingreso={selectedIngreso}
              formularioBloqueadoPorHojaQX={formularioBloqueadoPorHojaQX}
              diasHospitalarios={consultarDiasHospitalariosData?.diasHospitalarios ?? 3}
              diasRegistroEgresos={consultarDiasHospitalariosData?.diasRegistroEgresos ?? 5}
              consultarCoberturasCierreCuentaData={
                props?.consultarCoberturasCierreCuentaData
              }
              consultarCoberturasCierreCuentaLoading={
                consultarCoberturasCierreCuentaLoading
              }
              authUserData={props?.authUserData}
              onConsultarCoberturas={handleConsultarCoberturas}
              anioFormulario={anio}
              secuencialFormulario={numeroIngreso}
              validarServicioAmbulatorioData={validarServicioAmbulatorioData}
              validarServicioAmbulatorioLoading={validarServicioAmbulatorioLoading}
              tipoPssNoMedicoData={consultarTipoPssNoMedicoData}
              validarAfiliadoVigente={props.validarAfiliadoVigente}
              validarAfiliadoVigenteData={props.validarAfiliadoVigenteData}
              validarAfiliadoVigenteLoading={props.validarAfiliadoVigenteLoading}
              validarAfiliadoVigenteError={props.validarAfiliadoVigenteError}
              limpiarValidarAfiliadoVigente={props.limpiarValidarAfiliadoVigente}
              guardarEgreso={props.guardarEgreso}
              cambiarServicio={props.cambiarServicio}
              cambiarServicioData={props.cambiarServicioData}
              cambiarServicioLoading={props.cambiarServicioLoading}
              cambiarServicioError={props.cambiarServicioError}
              limpiarCambiarServicio={props.limpiarCambiarServicio}
              consultarReclamantes={props.consultarReclamantes}
              consultarReclamantesData={props.consultarReclamantesData}
              consultarReclamantesLoading={props.consultarReclamantesLoading}
              consultarReclamantesError={props.consultarReclamantesError}
              limpiarConsultarReclamantes={props.limpiarConsultarReclamantes}
              tieneDetalle={Array.isArray(selectedIngreso?.ingresoDetalle) && selectedIngreso.ingresoDetalle.length > 0}
            />
          </Section>
        </CheckRender>
      </PageWrapper>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,

  consultarIngresosPssData: state.egreso?.consultarIngresosPssData,
  consultarIngresosPssLoading:
    state.egreso?.consultarIngresosPssLoading,
  consultarIngresosPssError: state.egreso?.consultarIngresosPssError,

  consultarCoberturasCierreCuentaData:
    state.egreso?.consultarCoberturasCierreCuentaData,
  consultarCoberturasCierreCuentaLoading:
    state.egreso?.consultarCoberturasCierreCuentaLoading,
  consultarCoberturasCierreCuentaError:
    state.egreso?.consultarCoberturasCierreCuentaError,

  validarServicioAmbulatorioData:
    state.egreso?.validarServicioAmbulatorioData,
  validarServicioAmbulatorioLoading:
    state.egreso?.validarServicioAmbulatorioLoading,

  consultarTipoPssNoMedicoData:
    state.egreso?.consultarTipoPssNoMedicoData,

  validarAfiliadoVigenteData:
    state.egreso?.validarAfiliadoVigenteData,
  validarAfiliadoVigenteLoading:
    state.egreso?.validarAfiliadoVigenteLoading,
  validarAfiliadoVigenteError:
    state.egreso?.validarAfiliadoVigenteError,

  consultarReclamantesData:
    state.egreso?.consultarReclamantesData,
  consultarReclamantesLoading:
    state.egreso?.consultarReclamantesLoading,
  consultarReclamantesError:
    state.egreso?.consultarReclamantesError,

  cambiarServicioData:
    state.hojaQuirurgica?.cambiarServicioData,
  cambiarServicioLoading:
    state.hojaQuirurgica?.cambiarServicioLoading,
  cambiarServicioError:
    state.hojaQuirurgica?.cambiarServicioError,

  calcularOxigenoLoading:
    state.egreso?.calcularOxigenoLoading,

  consultarEstatusHojaQuirurgicaData:
    state.egreso?.consultarEstatusHojaQuirurgicaData,
  consultarEstatusHojaQuirurgicaLoading:
    state.egreso?.consultarEstatusHojaQuirurgicaLoading,
  consultarEstatusHojaQuirurgicaError:
    state.egreso?.consultarEstatusHojaQuirurgicaError,

  consultaIngresoDetalleCoberturaHojaQxData:
    state.egreso?.consultaIngresoDetalleCoberturaHojaQxData,
  consultaIngresoDetalleCoberturaHojaQxLoading:
    state.egreso?.consultaIngresoDetalleCoberturaHojaQxLoading,
  consultaIngresoDetalleCoberturaHojaQxError:
    state.egreso?.consultaIngresoDetalleCoberturaHojaQxError,

  consultarDiasHospitalariosData: state.egreso?.consultarDiasHospitalariosData,
});

const mapDispatchToProps = {
  consultarIngresosPss: EgresosActions.consultarIngresosPss,
  consultarCoberturasCierreCuenta:
    EgresosActions.consultarCoberturasCierreCuenta,
  limpiarIngresosPss: EgresosActions.limpiarIngresosPss,
  limpiarCoberturasCierreCuenta:
    EgresosActions.limpiarCoberturasCierreCuenta,
  validarServicioAmbulatorio:
    EgresosActions.validarServicioAmbulatorio,
  limpiarValidarServicioAmbulatorio:
    EgresosActions.limpiarValidarServicioAmbulatorio,
  consultarTipoPssNoMedico:
    EgresosActions.consultarTipoPssNoMedicoEgreso,
  validarAfiliadoVigente:
    EgresosActions.validarAfiliadoVigente,
  limpiarValidarAfiliadoVigente:
    EgresosActions.limpiarValidarAfiliadoVigente,
  guardarEgreso:
    EgresosActions.guardarEgreso,
  limpiarGuardarEgreso:
    EgresosActions.limpiarGuardarEgreso,
  cambiarServicio:
    EgresosActions.cambiarServicio,
  limpiarCambiarServicio:
    EgresosActions.limpiarCambiarServicio,
  consultarReclamantes:
    EgresosActions.consultarReclamantes,
  limpiarConsultarReclamantes:
    EgresosActions.limpiarConsultarReclamantes,
  consultarEstatusHojaQuirurgica:
    EgresosActions.consultarEstatusHojaQuirurgica,
  limpiarConsultarEstatusHojaQuirurgica:
    EgresosActions.limpiarConsultarEstatusHojaQuirurgica,
  limpiarConsultaIngresoDetalleCoberturaHojaQx:
    EgresosActions.limpiarConsultaIngresoDetalleCoberturaHojaQx,
  consultarDiasHospitalarios: EgresosActions.consultarDiasHospitalarios,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CierreCuentaClinicaScreen);
